export enum QuotePartListAction {
  ADD_LINE = 'addLine',
  CREATE_ORDER = 'createOrder',
  IMPORT = 'import',
  RELEASE_VERSION = 'releaseVersion',
  SUBMIT_ORDER = 'submitOrder',
}

export enum QuotePartInlineActionDrawer {
  ASSIGN_VENDOR = 'assignVendor',
  DETAILS = 'details',
  EDIT_LINE = 'editLine',
  UPDATE_MARGIN = 'updateMargin',
  UPDATE_PNB_MARGIN = 'updatePnbMargin',
}

export enum QuotePartColId {
  ADDER = 'adder',
  ALIAS = 'alias',
  ALL_INVENTORY = 'allInventory',
  ALTERNATE = 'alternate',
  ALTERNATE_VENDOR_PART_NUMBER = 'alternateVendorPartNumber',
  BASE = 'base',
  COST = 'cost',
  COST_SOURCE = 'costSource',
  CUSTOMER_PART_NUMBER = 'customerPartNumber',
  CUSTOMER_PO_LINE_NUMBER = 'customerPoLineNumber',
  DATASHEET = 'datasheet',
  DESCRIPTION = 'description',
  EDIT_LINE = 'editLine',
  EXT_PRICE = 'extPrice',
  EXT_PURCHASE_COST = 'extPurchaseCost',
  EXT_STANDARD_COST = 'extStandardCost',
  EXTERNAL_SPA_COST = 'externalSpaCost',
  EXTERNAL_SPA_COST_END_DATE = 'externalSpaCostEndDate',
  EXTERNAL_SPA_COST_REG_NUMBER = 'externalSpaCostRegistrationNum',
  EXTERNAL_SPA_COST_SOURCE = 'externalSpaCostSource',
  EXTERNAL_SPA_COST_SOURCE_NAME = 'externalSpaCostSourceName',
  FLOOR_PRICE = 'floorPrice',
  IMAGE = 'image',
  INVENTORY_STATUS = 'inventoryStatus',
  LINE = 'line',
  LINE_TYPE = 'lineType',
  LIST_PRICE = 'listPrice',
  LOCATION_INVENTORY = 'locationInventory',
  LOCKED = 'locked',
  MANUFACTURER = 'manufacturer',
  NOTES = 'notes',
  PACKAGING = 'packaging',
  PART_NUMBER = 'partNumber',
  PRICE = 'price',
  PRICE_SOURCE = 'priceSource',
  PRICING_DATE = 'pricingDate',
  PRICING_STRATEGY = 'pricingStrategy',
  QUANTITY = 'quantity',
  REPLACEMENT_COST = 'replacementCost',
  REPLACEMENT_COST_NUMBER = 'replacementCostNumber',
  SHIPMENT_TYPE = 'shipmentType',
  SHIPPING_LOCATION = 'location',
  STATUS = 'status',
  TAXONOMY = 'taxonomy',
  UNIFIED_PART_STATUS = 'ddpItemFlag',
  UOM = 'uom',
  VALIDATION_ERRORS = 'validationErrors',
  VALIDITY = 'validity',
  VENDOR = 'vendor',
  VENDOR_QUOTE = 'vendorQuote',
}

export enum QuotePartColField {
  COMPUTED_PURCHASE_COST = 'computedPurchaseCost',
  CORPORATE_LOCATION = 'corporateLocation',
  PRICE = 'price',
  QUANTITY = 'quantity',
  SHIPMENT_TYPE = 'shipmentType',
  UOM = 'uom',
}
